/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Document_ReplacedInputs */

const cs_enum_document_replaced = /** @type {(inputs: Enum_Document_ReplacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument nahrazen`)
};

const en_enum_document_replaced = /** @type {(inputs: Enum_Document_ReplacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document replaced`)
};

/**
* | output |
* | --- |
* | "Document replaced" |
*
* @param {Enum_Document_ReplacedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_document_replaced = /** @type {((inputs?: Enum_Document_ReplacedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Document_ReplacedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_document_replaced(inputs)
	return cs_enum_document_replaced(inputs)
});